export enum GlobalHelper {
  ReportResultNotApplicable = 'N/A',
}
